import React from 'react'

import { localizer, changeLanguage } from '../../Translator'

import { Link } from 'react-router-dom';

import { Container, Grid, Paper } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { TextFieldLoginStyled } from "../common/InputStyled"
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'

import { SnackbarCustom } from '../Utilities/SnackbarCustom';

import AuthCli from '../../sdk/AuthCli';

import MailCommsLogo from '../../images/mailcommsgroup-white.png'

import { LoginSelectRealm } from '../login/LoginSelectRealm';
import { LoginMfa } from '../login/LoginMfa';

const MFA_OPTION_EMAIL = 'Email'

export class LoginLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loginSuccess: false,
      loginWithMfa: false,
      loginWithRealm: false,

      // Login form fields.
      username: null,
      password: null,

      // Available realms for user.
      realms: [],

      // Url to navigate after login (/shipment if is null).
      callbackUrl: "shipment",

      // Message in case of error.
      errorMessage: null,

      // Flag to determinate if progress circle need to be shown.
      isLoading: false,
    }
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    let callbackUrl = queryParams.get('callback')

    if (callbackUrl) { this.setState({ callbackUrl: callbackUrl }) }

    this.getSessionInfo()
  }

  getSessionInfo = () => {
    this.setState({ isLoading: true })

    AuthCli.GetSessionInfo().then(async session => {
      if (session) {
        this.setState({ loginSuccess: true }, async () => {
          await this.setUserLanguage()

          await this.getAvailableRealmsForSession()
        })
      }
      this.setState({ isLoading: false })
      // User is completely logged in
      if(session && session.userEmail !== '' && session.realm !== '' && session.role !== '') { this.onLoginSuccessRedirect() }
    })
  }

  getAvailableRealmsForSession = async () => {
    // Request the list of realms available for the user.
    await AuthCli.GetAvailableRealmsForSession().then(realms => {
      if (!realms || realms.length === 0) return

      // Ignoring system and FACTORY__ realms for FrontOffice users
      realms = realms.filter(r => !r.realm.startsWith("system") && !r.realm.startsWith("FACTORY__"))
      this.setState({ realms: realms })

      // If there is only one realm, select it automatically
      if (realms.length === 1) {
        let realm = realms[0]

        this.changeSessionRealm(realm)
      }
      // Not filling realm & role info due to user must to select them
      if (realms.length > 1) { this.setState({ loginWithRealm: true }) }
    })
  }

  // Changing realm for user session
  changeSessionRealm = (realm) => {
    AuthCli.ChangeSessionRealm(realm.realm).then((data) => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ errorMessage: data.toString().substring(data.indexOf(' ')) })
        return
      }
      this.onLoginSuccessRedirect()
    })
  }

  /**
   * Asks the user service about the preferred language of the logged in
   * user and applies the corresponding translation.
   * If the user is not logged in attempting other options.
   */
  setUserLanguage = async () => {
    // To contain the language to be applied from now on.
    var language = null
    // TODO: ask desired language to user service.
    var preferred = null // TEMP
    // If not logged in, try if remembered the last language used in the browser.
    var lastUsed = window.localStorage.getItem("culture")
    // Take the best option.
    language = preferred || lastUsed || 'en'
    // Already translated to the desired language.
    if (localizer.getLanguage() === language) return;
    // Replace desired language by loading literals from the server.
    await changeLanguage(language)
    // Force the whole app to refresh in the new language.
    var handler = this.props.onLanguageChange
    if (handler != null) handler(language)
  }
  
  doLoginRequest = (mfacode) => {
    // Send credentials to the auth service.
    this.setState({ isLoading: true })

    AuthCli.LogIn({
      userEmail: this.state.username,
      userPassword: this.state.password,
      realm: '',
      delegateEmail: null,
      mfaCode: mfacode
    }).then(session => {
      if (!session) {
        this.setState({ errorMessage: localizer.IncorrectCredentials})
      } else if (session !== null && session.toString().startsWith("[ERR")) {
        this.setState({ errorMessage: session.toString().substring(session.indexOf(' ')) })
      } else {
        this.setState({ loginSuccess: true }, () => {
          // If user is already log in and MFA is required
          if (session.mfaProvider === MFA_OPTION_EMAIL && mfacode === null) {
            this.setState({ loginWithMfa: true })
            return
          }
          // If user is already log in and MFA login was successful
          if (session.mfaProvider === null && mfacode !== null) {
            this.setState({ loginWithMfa: false })
          }
          // Checking realms for user who is already log in
          this.getAvailableRealmsForSession()
        })
      }
      this.setState({ isLoading: false })
    })
  }

  onChange = (e) => { this.setState({ [e.target.name]: e.target.value }) }

  // In case of success log in
  onLoginSuccessRedirect = () => {
    window.location.href = AuthCli.SanitizeCallback(this.state.callbackUrl, "shipment")
  }

  // Closing error message.
  onClose = () => { this.setState({ errorMessage: null }) }

  render() {
    const buttonEnabled = !this.state.isLoading && this.state.username && this.state.password

    return (
      <React.Fragment>

        <Container className="login-container login-bg">
          {/* Login form. In case user is not log in yet */}
          {this.state.loginSuccess === false &&
            <Paper elevation={3} className="login-paper-container">
              <Grid container direction="row" style={{ position: "relative", top: "calc(50% - 180px)" }}>
                <Grid item md={12} className="text-align-center mb-20"> 
                  <Typography className="typography-generic login-title" >{localizer.WelcomePostamail}</Typography>
                </Grid>
                <Grid item md={12}>
                  <Typography className="typography-generic text-align-center font-weight-bold" >{localizer.PleaseLogIn}</Typography>
                </Grid>

                {/* Username Field */}
                <Grid item md={12} className="mt-20">
                  <TextFieldLoginStyled
                    className="login-textfield"
                    variant="outlined"
                    placeholder={localizer.Email}
                    name="username"
                    value={this.state.username ? this.state.username : ""}
                    onChange={(e) => { this.onChange(e) }}
                    fullWidth
                    inputRef={(input) => { if (input != null && this.focusOnEmail) { input.focus(); this.focusOnEmail = false } }}
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <i className="fa-solid fa-user font-size-15" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Password Field */}
                <Grid item md={12} className="mt-20">
                  <TextFieldLoginStyled
                    className="login-textfield"
                    variant="outlined"
                    placeholder={localizer.Password}
                    name="password"
                    type="password"
                    value={this.state.password ? this.state.password : ""}
                    onChange={(e) => { this.onChange(e) }}
                    onKeyDown={(e) => { if (e.key === 'Enter' && buttonEnabled) this.doLoginRequest(null) }}
                    fullWidth
                    inputRef={(input) => { if (input != null && this.focusOnPassword) { input.focus(); this.focusOnPassword = false } }}
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <i className="fa-solid fa-key font-size-15"></i>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Log in button. */}
                <Grid item md={12} className="mt-20">
                  <Button className="button-generic login" variant="contained" color="secondary" fullWidth disabled={!buttonEnabled} onClick={() => { this.doLoginRequest(null) }}>
                    {localizer.LogIn}
                  </Button>
                </Grid>
                 {/* Password forgotten link. */}
                <Grid item md={12}>
                  <Typography className="typography-generic text-align-center">
                    <Link className="link-hover font-weight-bold" to="/forgotpass">{localizer.ForgotPassword}</Link>
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          }

          {/* MFA form. In case user is login and MFA is required */}
          {this.state.loginSuccess === true && this.state.loginWithMfa === true &&
            <LoginMfa doLoginRequest={this.doLoginRequest}></LoginMfa>
          }

          {/* Realm selection. In case user is login and belongs to multiple realms */}
          {this.state.loginSuccess === true && this.state.loginWithRealm === true &&
            <LoginSelectRealm realms={this.state.realms} username={this.state.username} changeSessionRealm={this.changeSessionRealm} />
          }

          <Grid container direction="row" justify="flex-end" style={{ position: "absolute", bottom: "5px", right: "5px"}}>
            <img src={MailCommsLogo} width={200} alt="MailComms" />
          </Grid>

        </Container>

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

        {/* Error on login attempt. */}
        <SnackbarCustom message={this.state.errorMessage} severity="error" handleonClose={this.onClose} />

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/login/LoginLayout.js